<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="850px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <div class="images-container">
      <div class="d-flex flex-wrap block" v-if="!isEmpty || !disabled">
        <div v-for="(item, index) in listImage" :key="index">
          <div class="image-box">
            <span class="default-icon" v-if="item.isDefault === 'Y'">
              <i class="el-icon-success"></i>
            </span>
            <el-image
              style="width: 100%; height: 100%"
              fit="scale-down"
              :src="
                item.thumbImageUrl
                  ? $osscdn(item.thumbImageUrl)
                  : '/image/static/img/nopic.jpg'
              "
            ></el-image>
            <div class="shadow" v-if="!disabled">
              <div>
                <span @click="onImagePreview(index)">
                  <i class="el-icon-zoom-in"></i
                ></span>
              </div>
            </div>
          </div>
          <div style="text-align: center;">
            <el-checkbox v-model="item.isCheck"></el-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close()">{{ '取消' }}</el-button>
      <el-button size="small" type="primary" @click="confirm()">{{
        '确认'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    resFabricScmCode: { type: String, default: '' },
    resFabricInfoCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: {
      type: String,
      default: '图片维护',
    },
  },
  data() {
    return {
      listImage: [],
    }
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.listImage.map((item) => item.thumbImageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.resFabricInfoCode) return
      const res = await this.$api
        .resFabricInfoChooseListApi({
          resFabricScmCode: this.resFabricScmCode,
          resFabricInfoCode: this.resFabricInfoCode,
        })
        .catch(() => null)
      this.listImage = res.body.data
    },

    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    async confirm() {
      const checkImage = this.listImage.filter((item) => item.isCheck === true)
      if (!checkImage || checkImage.length == 0) {
        this.$message({
          showClose: true,
          message: '请选择图片!',
          type: 'warning',
        })
        return
      }
      const listImage = checkImage.map((m) => {
        return {
          resFabricInfoCode: m.resFabricInfoCode,
          imageCode: m.imageCode,
          imageUrl: m.imageUrl,
          thumbImageCode: m.thumbImageCode,
          thumbImageUrl: m.thumbImageUrl,
        }
      })
      this.loadingOpen()
      this.$api
        .resFabricInfoColorChooseSaveApi({
          resFabricInfoCode: this.resFabricInfoCode,
          listImage,
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功',
            type: 'success',
          })
          this.loadingClose()
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.images-container {
  min-height: 302px;
}

.side-frame-success {
  padding: 1px 5px 0 5px;
  border-left: 3px solid $color-primary;
  height: 26px;
}

.empty-image {
  height: 302px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
